<template>
  <div class="life-card">
    <page-header title="Life Card" />
    <page-section>
      <v-layout align-center justify-center>
        <card-model
          v-bind="{
            dataCard: cardFront,
            isChipMouseOver,
            getData,
            getStyleChip,
            onShowModal,
            onChipMouseOver,
            onChipMouseLeave,
            showModalExport,
            exportCard,
            cliente,
            qrCodeImage,
            qrCodeImageStatus,
          }"
        />
      </v-layout>
      <v-dialog
        v-model="showModalExport"
        width="100vh"
        class="wireframe"
        content-class="wireframe"
        style="position: relative; width: 598px; overflow: hidden"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-layout justify-center class="mt-5">
            <v-btn
              small
              v-bind="attrs"
              v-on="on"
              @click="exportCard"
              color="primary"
              >Exportar</v-btn
            >
          </v-layout>
        </template>
        <card-model-print
          v-bind="{
            dataCard: cardFront,
            getData,
            cliente,
            qrCodeImage,
            qrCodeImageStatus,
          }"
        />
      </v-dialog>
      <v-dialog
        v-model="showModal"
        persistent
        max-width="380px"
        scrollable
        content-class="ma-2 ma-sm-3"
      >
        <v-card>
          <v-card-subtitle>
            <v-card-text>
              <div>{{ $i18n.t("click_nas_setas_mover_ordem") }}</div>
              <div>{{ $i18n.t("click_no_olho_ocultar_exibir") }}</div>
              <div
                class="py-2"
                :class="
                  getCountFiledsSelecteds > maxNumberOfFields
                    ? 'red--text text--lighten-1'
                    : ''
                "
              >
                Campos selecionados:
                <b>{{ getCountFiledsSelecteds }} de {{ maxNumberOfFields }}</b>
              </div>
              <div
                class="caption"
                v-if="getCountFiledsSelecteds > maxNumberOfFields"
                :class="
                  getCountFiledsSelecteds > maxNumberOfFields
                    ? 'red--text text--lighten-1'
                    : ''
                "
              >
                {{ $i18n.t("numero_maximo_alcancado", { maxNumberOfFields }) }}
              </div>
            </v-card-text>
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text id="card-content" style="max-height: 480px">
            <v-list>
              <v-list-item
                :id="'card-list-item__' + i"
                class="card-list-item"
                v-for="(item, i) in editcardFront"
                :key="i"
              >
                <v-layout column>
                  <v-layout justify-space-between align-center>
                    <div class="mr-8">
                      <v-icon
                        v-if="item.show"
                        @click="item.show = !item.show"
                        :color="item.show ? 'blue lighten-0' : ''"
                        >mdi-eye</v-icon
                      >
                      <v-icon v-else @click="item.show = !item.show"
                        >mdi-eye-off</v-icon
                      >
                    </div>
                    <v-layout justify-center align-center>
                      {{ $i18n.t(item.text) }}
                    </v-layout>
                    <v-layout
                      column
                      align-center
                      justify-space-between
                      class="flex-grow-0"
                    >
                      <v-btn
                        icon
                        v-show="i > 0"
                        :class="i < editcardFront.length - 1 ? 'mb-6' : 'my-6'"
                        :retain-focus-on-click="false"
                        :color="getSytleBtnMove(i, 'up').color"
                        @mouseover="onBtnMoveMouseOver(i, 'up')"
                        @mouseleave="onBtnMoveMouseLeave"
                        @click="onSwitchField(item, 'up')"
                      >
                        <v-icon> mdi-arrow-up-circle </v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        v-show="i < editcardFront.length - 1"
                        :class="i > 0 ? 'mb-0' : 'my-6'"
                        :retain-focus-on-click="false"
                        :color="getSytleBtnMove(i, 'down').color"
                        @mouseover="onBtnMoveMouseOver(i, 'down')"
                        @mouseleave="onBtnMoveMouseLeave"
                        @click="onSwitchField(item, 'down')"
                      >
                        <v-icon> mdi-arrow-down-circle </v-icon>
                      </v-btn>
                    </v-layout>
                  </v-layout>
                  <v-divider class="my-4"></v-divider>
                </v-layout>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-card-text>
              <v-layout justify-space-around>
                <v-btn color="grey darken-1" text @click="onCancelEditCard">
                  Cancelar
                </v-btn>
                <v-btn
                  :disabled="getCountFiledsSelecteds > maxNumberOfFields"
                  color="blue darken-1"
                  text
                  @click="onSaveEditCard"
                  class="ml-3"
                >
                  Salvar
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </page-section>
  </div>
</template>

<script>
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import html2canvas from "html2canvas";
import CardModel from "@/components/widgets/card-model";
import i18next from "i18next";
import CardModelPrint from "@/components/widgets/card-model-print";
import { updateData } from "@/services";

export default {
  metaInfo: {
    titleTemplate: "Life Card | %s",
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.user.token) {
        vm.$router.push("/");
      }
    });
  },
  components: { CardModelPrint, CardModel, PageSection, PageHeader },
  data: () => ({
    showModal: false,
    showModalExport: false,
    isChipMouseOver: -1,
    isBtnMoveMouseOver: [-1, ""],
    styleChipOnMouseOver: {
      textColor: "blue lighten-0",
    },
    styleChipOnMouseLeave: {
      textColor: "black lighten-0",
    },
    styleBtnMoveOnMouseOver: {
      color: "blue lighten-0",
    },
    cardFront: [],
    cardBack: [],
    editcardFront: [],
    editcardBack: [],
    cardFrontPet: [
      { text: "Raca", field: "raca", type: "string", show: false },
      { text: "Idade", field: "idade", type: "string", show: false },
      { text: "Nome_Dono", field: "nomeDono", type: "string", show: false },
      { text: "Racao", field: "tipoRacao", type: "string", show: false },
      {
        text: "Nome_Cuidador",
        field: "nomeCuidador",
        type: "string",
        show: false,
      },
      { text: "Telefone_Dono", field: "foneDono", type: "string", show: false },
      {
        text: "Telefone_Cuidador",
        field: "foneCuidador",
        type: "string",
        show: false,
      },
      { text: "Castrado", field: "castrado", type: "boolean", show: false },
      { text: "Pedigree", field: "pedigree", type: "boolean", show: false },
      {
        text: "Veterinario",
        field: "nomeVeterinario",
        type: "string",
        show: false,
      },
      {
        text: "Telefone_Clinica",
        field: "foneVeterinario",
        type: "string",
        show: false,
      },
      {
        text: "Empresa",
        field: "empresaVeterinario",
        type: "string",
        show: false,
      },
    ],
    cardBackPet: [],
    cardFrontPessoa: [
      { text: "Email", field: "email", type: "string", show: false },
      { text: "Data_Nasc", field: "dataNasc", type: "string", show: false },
      {
        text: "Nome_Contato",
        field: "nomeContato",
        type: "string",
        show: false,
      },
      {
        text: "Email_Contato",
        field: "emailContato",
        type: "string",
        show: false,
      },
      {
        text: "Telefone_1",
        field: "fone1Contato",
        type: "string",
        show: false,
      },
      {
        text: "Telefone_2",
        field: "fone2Contato",
        type: "string",
        show: false,
      },
      { text: "Peso", field: "peso", type: "string", show: false },
      { text: "Altura", field: "altura", type: "string", show: false },
      { text: "Tipo_Sangue", field: "tipoSangue", type: "string", show: false },
      {
        text: "Aceita_Transfusao_Sangue",
        field: "aceitaTransfusaoSangue",
        type: "string",
        show: false,
      },
      {
        text: "medicacao_anti_coagulo",
        field: "usaMedicacaoAntiCoagulo",
        type: "string",
        show: false,
      },
      {
        text: "Doador_Orgaos",
        field: "doadorOrgaos",
        type: "string",
        show: false,
      },
      {
        text: "Número do SUS",
        field: "numeroSus",
        type: "string",
        show: false,
      },
      { text: "Nome_Medico", field: "nomeMedico", type: "string", show: false },
      {
        text: "Telefone_Medico",
        field: "foneMedico",
        type: "string",
        show: false,
      },
      { text: "Empresa", field: "empresaMedico", type: "string", show: false },
    ],
    cardBackPessoa: [],
    maxNumberOfFields: 9,
    minNumberOfFields: 3,
    petDefaultFields: ["raca", "idade", "nomeDono"],
    pessoaDefaultFields: ["nome", "idade", "dataNasc"],
    qrCodeImage: null,
    qrCodeImageStatus: 0,
  }),
  computed: {
    getStyleChip() {
      return (index) =>
        this.isChipMouseOver === index
          ? this.styleChipOnMouseOver
          : this.styleChipOnMouseLeave;
    },
    getSytleBtnMove() {
      return (index, type) =>
        this.isBtnMoveMouseOver[0] === index &&
        this.isBtnMoveMouseOver[1] === type
          ? this.styleBtnMoveOnMouseOver
          : "";
    },
    cliente() {
      return this.$store.state.cliente.data || {};
    },
    pessoa() {
      return this.$store.state.pessoa.data || {};
    },
    pet() {
      return this.$store.state.pet.data || {};
    },
    getCountFiledsSelecteds() {
      return this.editcardFront.filter((e) => e.show).length;
    },
    getData() {
      return (item) => {
        const data =
          this.$store.state[this.$store.state.context].data[item.field] || {};
        switch (item.type) {
          case "string":
            return data;
          case "boolean":
            return data ? i18next.t("Sim") : i18next.t("Nao");
        }
        return data;
      };
    },
  },
  mounted() {
    this.onInitCardFront();
  },
  methods: {
    getID(id) {
      return id.split("/")[2];
    },
    onInitCardFront() {
      this.qrCodeImageStatus = 1;

      if (this.$store.state.context === "pet") {
        this.$store.dispatch("pet/getQRCodeImage", {
          token: this.$store.state.auth.user.token,
          callbackSuccess: (data) => {
            this.qrCodeImage = data;
            this.qrCodeImageStatus = 0;
          },
          callbackError: () => {
            this.qrCodeImageStatus = -1;
          },
        });

        // se o campo estiver nulo, atribui os campos defaults
        if (!this.pet.cartaoFrente)
          this.pet.cartaoFrente = this.petDefaultFields.join(",");

        const cartaoFrente = Array.from(
          new Set([
            ...this.pet.cartaoFrente.split(","),
            ...this.petDefaultFields,
          ])
        );

        // para cada campo que foi incluido deve atribuir ser exibido
        cartaoFrente.forEach((e, i) => {
          const item = this.cardFrontPet.find((f) => f.field === e);
          item.show = true;
          this.cardFront[i] = item;
        });

        // incluir os demais campos que não estão sendo exibidos
        this.cardFront = Array.from(
          new Set([...this.cardFront, ...this.cardFrontPet])
        );
      } else if (this.$store.state.context === "pessoa") {
        this.$store.dispatch("pessoa/getQRCodeImage", {
          token: this.$store.state.auth.user.token,
          callbackSuccess: (data) => {
            this.qrCodeImage = data;
            this.qrCodeImageStatus = 0;
          },
          callbackError: () => {
            this.qrCodeImageStatus = -1;
          },
        });

        // se o campo estiver nulo, atribui os campos defaults
        if (!this.pessoa.cartaoFrente)
          this.pessoa.cartaoFrente = this.pessoaDefaultFields.join(",");

        const cartaoFrente = Array.from(
          new Set([
            ...this.pessoa.cartaoFrente.split(","),
            ...this.pessoaDefaultFields,
          ])
        );

        // para cada campo que foi incluido deve atribuir ser exibido
        cartaoFrente.forEach((e, i) => {
          const item = this.cardFrontPessoa.find((f) => f.field === e);
          item.show = true;
          this.cardFront[i] = item;
        });

        // incluir os demais campos que não estão sendo exibidos
        this.cardFront = Array.from(
          new Set([...this.cardFront, ...this.cardFrontPessoa])
        );
      }
    },
    onShowModal(index) {
      this.editcardFront = JSON.parse(JSON.stringify(this.cardFront));
      this.showModal = true;

      this.$nextTick(() => {
        const cardScroll = document.querySelector("#card-content");
        if (cardScroll) {
          cardScroll.scrollTo(0, 96 * index);
        }
      });
    },
    onSaveEditCard() {
      if (
        this.editcardFront.filter((e) => e.show).length >=
        this.minNumberOfFields
      ) {
        const context = this.$store.state.context;

        const fields = this.editcardFront
          .map((e) => {
            if (e.show) return e.field;
          })
          .filter((e) => e);

        this[context].cartaoFrente = fields.join(",");

        updateData(this, context, this[context]);

        this.cardFront = this.editcardFront;

        this.showModal = false;
      } else {
        this.$store.commit("setSnackbarError", {
          status: true,
          message: i18next.t("minimo_campos_exibidos"),
        });
      }
    },
    onCancelEditCard() {
      this.showModal = false;
    },
    onSwitchField(item, moviment) {
      const indexFrom = this.editcardFront.indexOf(item);
      const itemFrom = item;
      let indexTo;
      let itemTo;

      if (moviment === "down") {
        indexTo =
          indexFrom + 1 < this.editcardFront.length ? indexFrom + 1 : indexFrom;
        itemTo = this.editcardFront[indexTo];
      } else {
        indexTo = indexFrom - 1 >= 0 ? indexFrom - 1 : indexFrom;
        itemTo = this.editcardFront[indexTo];
      }

      effectSwitchListItem(indexTo, indexFrom, moviment);

      delay(() => {
        this.editcardFront.splice(indexTo, 1, itemFrom);
        this.editcardFront.splice(indexFrom, 1, itemTo);
      }, 200);

      function effectSwitchListItem(indexTo, indexFrom, moviment) {
        effectFadeOutListItem(indexFrom, moviment);
        effectFadeOutListItem(indexTo, moviment === "up" ? "down" : "up");
      }

      function effectFadeOutListItem(index, moviment) {
        const cardListItem = document.querySelector(
          "#card-list-item__" + index
        );
        effectTransition(cardListItem, moviment);
      }

      function effectTransition(elementHTML, moviment) {
        if (elementHTML) {
          if (!elementHTML.classList.contains("transition-in"))
            elementHTML.classList.add("transition-in");
          elementHTML.classList.add(`fade-out-${moviment}-list-item`);
          delay(() => {
            elementHTML.classList.add("transition-out");
          }, 200);

          delay(() => {
            elementHTML.classList.remove("transition-in");
            elementHTML.classList.remove(`fade-out-${moviment}-list-item`);
            elementHTML.classList.remove("transition-out");
          }, 400);
        }
      }

      function delay(callback, millis) {
        const time = setTimeout(() => {
          callback && callback();
          clearTimeout(time);
        }, millis);
      }
    },
    onChipMouseOver(i) {
      this.isChipMouseOver = i;
    },
    onChipMouseLeave() {
      this.isChipMouseOver = -1;
    },
    onBtnMoveMouseOver(i, type) {
      this.isBtnMoveMouseOver = [i, type];
    },
    onBtnMoveMouseLeave() {
      this.isBtnMoveMouseOver = [-1, ""];
    },
    exportCard() {
      const time = setTimeout(() => {
        const html = document.querySelector("#print-card");
        html2canvas(html, { width: 310, height: 196, scale: 1 }).then(
          (canvas) => {
            // criar um elemento de link temporario
            const link = document.createElement("a");
            document.body.appendChild(link);
            link.download =
              "life-card-" +
              this.$store.state[this.$store.state.context].uid.replace(
                /\//g,
                "-"
              ) +
              ".png";
            link.href = canvas.toDataURL();
            link.target = "_blank";
            const click_time = setTimeout(() => {
              link.click(); // efetuar a ação do download do arquivo
              link.remove(); // remover o elemento temporario
              this.showModalExport = false;
              clearTimeout(click_time);
            }, 3000);
          }
        );
        clearTimeout(time);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.card-list-item {
  &.transition-in {
    transition: all 0.2s ease-in-out;
    opacity: 1;
  }

  &.fade-out-up-list-item {
    transform: translateY(-40px);
    opacity: 0;
  }

  &.fade-out-down-list-item {
    transform: translateY(40px);
    opacity: 0;
  }

  &.transition-out {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
